import { PureComponent } from 'react';

import { makeSelectMessages } from 'containers/LanguageProvider/selectors';
import { closeDialogue } from 'containers/LeaveDialogue/actions';
import { Record } from 'immutable';
import { fetchAdvanced } from 'pages/Settings//DiscoverySnapshots/GlobalDiscoveryConfiguration/actions';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import fetch from 'utils/fetch';
import handleEvent from 'utils/handleEvent';
import Syslog from './Syslog';
import { saveSyslog } from './actions';
import { selectSettingsConfigurationManagement } from './selectors';

@fetch({ actions: [fetchAdvanced] })
class ConfigurationManagement extends PureComponent {
  static propTypes = {
    componentAsPage: PropTypes.bool,
    saveChangeOnLeave: PropTypes.bool,
    msg: PropTypes.object,
    onCloseLeaveDialogue: PropTypes.func.isRequired,
    onSaveSyslog: PropTypes.func.isRequired,
    syslog: PropTypes.instanceOf(Record),
  };

  static defaultProps = {
    componentAsPage: true,
    saveChangeOnLeave: false,
  };

  handleSubmit = handleEvent((values) => {
    const { onSaveSyslog } = this.props;
    onSaveSyslog({ values, returnUrl: this.returnUrl });
  });

  handleSetReturnUrl = handleEvent((returnUrl) => {
    this.returnUrl = returnUrl;
  });

  render() {
    const {
      componentAsPage,
      saveChangeOnLeave,
      msg: {
        settingsConfigurationManagement: msg,
        scheduleField,
        leaveDialogue: leaveDialogueMessages,
      },
      onCloseLeaveDialogue,
      syslog,
    } = this.props;
    return (
      <div className='m-4'>
        <div className='box box-solid mb-0 flex flex-1 flex-col'>
          <div className='box-body flex flex-1 flex-col'>
            <Helmet title={msg.title} />
            <h2>{msg.title}</h2>
            <Syslog
              componentAsPage={componentAsPage}
              saveChangeOnLeave={saveChangeOnLeave}
              initialValues={syslog}
              leaveDialogueMessages={leaveDialogueMessages}
              msg={msg}
              msgScheduleField={scheduleField}
              onSetReturnUrl={this.handleSetReturnUrl}
              onSubmit={this.handleSubmit}
              onSubmitFail={onCloseLeaveDialogue}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  msg: makeSelectMessages(),
  syslog: selectSettingsConfigurationManagement,
});

function mapDispatchToProps(dispatch) {
  return {
    onCloseLeaveDialogue: () => dispatch(closeDialogue()),
    onSaveSyslog: (args) => dispatch(saveSyslog(args)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfigurationManagement);
